module.exports = __webpack_public_path__ + "static/media/graph2.94735065.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/spring/graph2.png
// module id = 152
// module chunks = 0